var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7232 26.7296C56.0787 24.1024 57.5282 20.6597 57.8 16.9453H43.9388L53.7232 26.7296Z",
    fill: "#2E406F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6705 0V15.1295H57.8C57.347 6.97586 50.8241 0.452978 42.6705 0Z",
    fill: "#2E406F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8586 0C32.4332 0.452978 25.7291 7.42884 25.7291 16.0354C25.7291 24.642 32.9768 32.0708 41.7645 32.0708C45.8414 32.0708 49.6464 30.5307 52.4548 27.994L40.8586 16.3978V0Z",
    fill: "#2E406F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9172 16.042C23.9172 9.79093 27.1787 4.2646 32.0708 1.09375H4.62038C2.0837 1.09375 0 3.17745 0 5.71413V53.0956C0 55.6323 2.0837 57.716 4.62038 57.716H43.0329C45.5696 57.716 47.6533 55.6323 47.6533 53.0956V32.8928C45.7508 33.527 43.7577 33.8894 41.7646 33.8894C31.8897 33.8894 23.9172 25.9169 23.9172 16.042ZM12.5022 50.6495H7.97241V25.011H12.5022V50.6495ZM21.5618 50.6495H17.032V30.4467H21.5618V50.6495ZM30.6213 50.6495H26.0915V35.9731H30.6213V50.6495ZM39.6809 50.6495H35.1511V41.59H39.6809V50.6495Z",
    fill: "#2E406F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportEmptyIcon);
export default __webpack_public_path__ + "static/media/ReportEmptyIcon.6bdb4aeddad58c89d64f29947ff15b92.svg";
export { ForwardRef as ReactComponent };